class VimeoVideo {
  constructor(el) {
    this.el = el;
    this.videoId = el.dataset.videoId;
    this.container = el.querySelector('div[data-video-container]');
    this.button = el.querySelector('button[data-video-play]');

    if (!this.container) {
      console.warn('A video implementation is missing a video container.');
      return;
    }

    if (!this.button) {
      console.warn('A video implementation is missing a play button.');
      return;
    }

    if (typeof Vimeo === 'undefined') {
      console.warn('Something went wrong loading the Vimeo player SDK.');
      return;
    }

    this.init();
    this.setupListeners();
  }

  init() {
    this.player = new window.Vimeo.Player(this.container, {
      id: this.videoId,
    });
  }

  setupListeners() {
    this.button.addEventListener('click', this.handlePlay.bind(this));
  }

  handlePlay() {
    this.el.classList.add('video-playing');
    this.player.play();
  }
}

export default VimeoVideo;
